// extracted by mini-css-extract-plugin
export default {"separatorBefore":"Separator_separatorBefore__8UYgh","separatorAfter":"Separator_separatorAfter__yFcJL"};